export enum PaymentMethods {
  Card = 'card',
  PayPal = 'paypal',
  ApplePay = 'applepay',
}
